import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ReduxStore} from './redux/store';
import './i18n';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import './index.css';
import './main.css';
import './semantic/dist/semantic.min.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

if (process.env.NODE_ENV !== 'development') {
    const originalWarn = console.warn;
    const originalInfo = console.info;

    const suppressedPatterns = [
        /componentWillMount has been renamed/i,
        /componentWillReceiveProps has been renamed/i,
        /componentWillUpdate has been renamed/i,
        /`value` prop on `input` should not be null/i,
        /changing an uncontrolled input of type text to be controlled/i,
        /React\.createFactory\(\) is deprecated/i, // Suppress React.createFactory warning
    ];

    // Suppress console.warn
    console.warn = (...args: any[]) => {
        const text = args.join(' ');
        if (suppressedPatterns.some(p => p.test(text))) {
            // Suppress legacy React warnings temporarily. Remove after upgrades.
            return;
        }
        originalWarn(...args);
    };
}

ReactDOM.render(
    <Provider store={ReduxStore}>
        <App />
    </Provider>
    ,
    document.getElementById('root') as HTMLElement
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx